var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"wap-intro",domProps:{"innerHTML":_vm._s(_vm.webinarInfo.intro)}})])}
var staticRenderFns = []

export { render, staticRenderFns }